module.exports = __webpack_public_path__ + "media/images/flags/wf-1d58a8d49089620cbfabdc33f954e677.svg";